export default function TopThreatsDirective() {
  return {
    template: require('./top-threats.html'),
    scope: {
      process: '=',
      isEditable: '=',
    },
    controller: 'TopThreatsController',
    controllerAs: 'topThreatsVM',
    bindToController: true,
    replace: true,
  };
}
